var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tw-p-6"
  }, [_c('b-row', [_c('b-col', [_c('h1', {
    staticClass: "h1"
  }, [_vm._v(" Earnings ")])]), _c('b-col', {
    staticClass: "tw-flex tw-items-center tw-gap-x-4",
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "tw-mt-2",
    attrs: {
      "name": "check-button-hide-v1",
      "switch": "",
      "size": "sm"
    },
    model: {
      value: _vm.hideV1Earnings,
      callback: function ($$v) {
        _vm.hideV1Earnings = $$v;
      },
      expression: "hideV1Earnings"
    }
  }, [_vm._v(" Hide v1 Earnings ")]), _c('b-form-checkbox', {
    staticClass: "tw-mt-2",
    attrs: {
      "name": "check-button",
      "switch": "",
      "size": "sm"
    },
    model: {
      value: _vm.isZeroValuesHidden,
      callback: function ($$v) {
        _vm.isZeroValuesHidden = $$v;
      },
      expression: "isZeroValuesHidden"
    }
  }, [_vm._v(" Hide zero values ")]), _c('b-form-checkbox', {
    staticClass: "tw-mt-2",
    attrs: {
      "name": "check-button-inactive",
      "switch": "",
      "size": "sm"
    },
    model: {
      value: _vm.showInactiveDoctors,
      callback: function ($$v) {
        _vm.showInactiveDoctors = $$v;
      },
      expression: "showInactiveDoctors"
    }
  }, [_vm._v(" Show Inactive Doctors ")]), _c('b-form-checkbox', {
    staticClass: "tw-mt-2",
    attrs: {
      "name": "check-button-exclude-test-data",
      "switch": "",
      "size": "sm"
    },
    model: {
      value: _vm.excludeTestData,
      callback: function ($$v) {
        _vm.excludeTestData = $$v;
      },
      expression: "excludeTestData"
    }
  }, [_vm._v(" Exclude Test Data ")]), _c('b-dropdown', {
    attrs: {
      "variant": "link",
      "right": "",
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('span', {
          staticClass: "dropdown-toggle d-letter-spacing",
          attrs: {
            "id": "sidebarIcon",
            "href": "#",
            "role": "button",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }
        }, [_c('div', {
          staticClass: "account-body d-none d-sm-none d-md-block mr-4"
        }, [_c('h3', {
          staticClass: "mb-0"
        }, [_vm._v(" " + _vm._s(_vm.currentFilter) + " ")])]), _c('b-icon', {
          attrs: {
            "icon": "caret-down-fill",
            "font-scale": "0.75"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        _vm.currentFilter = 'Last Month';
      }
    }
  }, [_vm._v(" Last Month ")]), _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        _vm.currentFilter = 'Month to Date';
      }
    }
  }, [_vm._v(" Month to Date ")]), _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        _vm.currentFilter = 'Year to Date';
      }
    }
  }, [_vm._v(" Year to Date ")]), _c('b-dropdown-item', {
    on: {
      "click": function ($event) {
        _vm.currentFilter = 'All Time';
      }
    }
  }, [_vm._v(" All Time ")]), _c('b-dropdown-item', {
    nativeOn: {
      "!click": function ($event) {
        $event.stopPropagation();
        _vm.showCustom = true;
      }
    }
  }, [_vm._v(" Custom ")]), _vm.showCustom ? _c('b-dropdown-divider') : _vm._e(), _vm.showCustom ? _c('b-dropdown-form', [_c('span', {
    staticClass: "text-small text-muted"
  }, [_vm._v("From")]), _c('b-form-select', {
    attrs: {
      "options": _vm.months
    },
    model: {
      value: _vm.fromMonth,
      callback: function ($$v) {
        _vm.fromMonth = $$v;
      },
      expression: "fromMonth"
    }
  }), _c('b-form-select', {
    attrs: {
      "options": _vm.years
    },
    model: {
      value: _vm.fromYear,
      callback: function ($$v) {
        _vm.fromYear = $$v;
      },
      expression: "fromYear"
    }
  }), _c('span', {
    staticClass: "text-small text-muted"
  }, [_vm._v("To")]), _c('b-form-select', {
    attrs: {
      "options": _vm.months
    },
    model: {
      value: _vm.toMonth,
      callback: function ($$v) {
        _vm.toMonth = $$v;
      },
      expression: "toMonth"
    }
  }), _c('b-form-select', {
    attrs: {
      "options": _vm.years
    },
    model: {
      value: _vm.toYear,
      callback: function ($$v) {
        _vm.toYear = $$v;
      },
      expression: "toYear"
    }
  }), _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": _vm.getEarningData
    }
  }, [_vm._v(" Search ")])], 1) : _vm._e()], 1)], 1)], 1), _c('DoctorEarningsTable', {
    ref: "DoctorEarningsTable",
    attrs: {
      "current-filter": _vm.currentFilter,
      "hide-zero-values": _vm.isZeroValuesHidden,
      "show-inactive-doctors": _vm.showInactiveDoctors,
      "hide-v1-earnings": _vm.hideV1Earnings,
      "exclude-test-data": _vm.excludeTestData
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };